<template>
	<div id="app">
		<transition v-if="!$route.meta.NoNeedHome" name="fade" mode="out-in">
			<el-row class="container">
				<el-col :span="24" class="header">
					<el-col :span="10" class="logo collapsedLogo" :class="collapsed ? 'logo-collapse-width' : 'logo-width'">
						<div @click="toindex" class="shop_title">
							<!--              {{ collapsed ? sysNameShort : sysName }}-->
							<span v-if="$store.state.tenancyName && $store.state.tenantId">
								{{ collapsed ? sysNameShort : $store.state.tenancyName }}
							</span>
							<!--              <span v-else>ERP系统</span>-->
							<span v-else style="font-size:17px">营客通ERP管理系统</span>

						</div>
					</el-col>
					<el-col :span="10" class="logoban">
						<div :class="collapsed ? 'tools collapsed' : 'tools'" @click="collapse">
							<i class="fa fa-align-justify"></i>
						</div>

						<el-breadcrumb separator="/" class="breadcrumb-inner collapsedLogo">
							<el-breadcrumb-item v-for="(item, index) in $route.matched" :key="index">
								<span>{{ item.name }}</span>
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="4" class="userinfo">
						<p style="color: #fff;font-size: 14px;margin-right:15px;cursor: pointer;" @click="agree">
							<span>入驻协议</span>
						</p>
						<p style="color: #fff;font-size: 14px;margin-right:15px;cursor: pointer;" @click="onFormat">
							<span>格式化工具</span>
						</p>
						<p style="color: #fff;font-size: 14px;margin-right:15px;cursor: pointer;" @click="operationManual">
							<span>操作手册</span>
						</p>
						<el-popover placement="bottom" trigger="hover">
							<div>
								<p>1、商品列表批量上下架</p>
								<p>2、商品列表快捷修改默认库存</p>
								<p>3、商品列表快捷修改价格</p>
								<p>4、商品详情加入商品整体起购数量</p>
								<p>5、订单列表恢复接单（辅助功能，非必需操作）</p>
								<p>6、如果发生售后订单列表会提示有：有进行中售后</p>
								<p>7、恢复商品素材库，点击即可复制商品，不在手动添加</p>
								<p>注：erp订单调整，取消订单推送，用户下单即可接收到订单，取消商城订单推送。只需要发货即可。
									商品信息不在需要进行同步，直接修改即可。</p>
							</div>
							<span slot="reference"
								style="display:inline-block;height:60px;line-height:60px;cursor: pointer;color: #fff;font-size: 14px;margin-right:15px;">更新通知</span>
						</el-popover>
						<span @click="getQrCode"
							style="display:inline-block;height:60px;line-height:60px;cursor: pointer;color: #fff;font-size: 14px;margin-right:15px;">通知服务</span>
						<p class="up_data_icon" @click="handleOpenUpdata()">
							<i class="el-icon-upload"></i>
							<span>下载中心</span>
						</p>
						<el-dropdown trigger="hover">
							<span class="el-dropdown-link userinfo-inner">
								<!--                {{ sysUserName }}-->
								{{ $store.state.isSignIn1Data || '管理员' }}
								<!--               {{ localStorage.getItem('isSignIn1').emailAddress }}-->
								<img src="./assets/logo.png" height="128" width="128" />
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="Setting">设置
								</el-dropdown-item>
								<el-dropdown-item divided @click.native="logout">退出登录
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-col>
				</el-col>
				<el-col :span="24" class="main">
					<aside :class="collapsedClass">
						<el-scrollbar style="height: 100%; background: #232c32" class="scrollbar-handle">
							<el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen"
								@close="handleclose" @select="handleselect" unique-opened router :collapse="isCollapse"
								background-color="#232c32" style="border-right: none" text-color="#fff" active-text-color="#409EFF">
								<sidebar v-for="(menu, index) in routes" @collaFa="collapseFa" :key="index" :item="menu" />
							</el-menu>
						</el-scrollbar>
					</aside>
					<el-col :span="24" class="content-wrapper" :class="collapsed ? 'content-collapsed' : 'content-expanded'">
						<div class="tags" v-if="showTags">
							<div id="tags-view-container" class="tags-view-container">
								<scroll-pane ref="scrollPane" class="tags-view-wrapper">
									<router-link v-for="(tag, index) in tagsList" ref="tag" :key="index"
										:class="{ active: isActive(tag.path) }" :to="{
											path: tag.path,
											query: tag.query,
											fullPath: tag.fullPath,
										}" tag="span" @click.middle.native="closeTags(index)" class="tags-view-item">
										{{ tag.title }}
										<span class="el-icon-close" @click.prevent.stop="closeTags(index)" />
									</router-link>
								</scroll-pane>
							</div>
							<!-- 其他操作按钮 -->
							<div class="tags-close-box">
								<el-dropdown @command="handleTags">
									<el-button size="mini">
										<i class="el-icon-arrow-down el-icon--right"></i>
									</el-button>
									<el-dropdown-menu size="small" slot="dropdown">
										<el-dropdown-item command="other">关闭其他
										</el-dropdown-item>
										<el-dropdown-item command="all">关闭所有</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>
						<transition name="fade" mode="out-in">
							<div class="content-az">
								<div style="color:red;padding:0 0 20px 20px;background:#fff;position: relative;z-index: 1;font-size:14px;"
									ref="ruleContent">
									<p>空调商品报装推单规则: 1. 上班时间内<span class="red">早9：00-晚18:00</span>，<span class="red">2小时内</span>完成推单，反馈单号；2.
										超时未反馈推单结果的，平台将付费进行该订单的推单，费用<span class="red">10元/台</span>，在货款扣减</p>
									<p>关于供货商售后审核时效的说明: 用户提交退款申请且系统无物流信息，48 小时内供货商群内无反馈、后台未审核的，客服可直接审核退款；后续若货物已发出，相关事宜由供货商自行处理。</p>
								</div>
								<div :style="{ height: `calc(100% - 100px)` }">
									<keep-alive>
										<router-view v-if="$route.meta.keepAlive"></router-view>
									</keep-alive>
									<router-view v-if="!$route.meta.keepAlive"></router-view>
								</div>
							</div>
						</transition>
					</el-col>
				</el-col>
			</el-row>
		</transition>

		<transition v-else name="fade" mode="out-in">
			<div class="content-az">
				<keep-alive>
					<router-view v-if="$route.meta.keepAlive"></router-view>
				</keep-alive>
				<router-view v-if="!$route.meta.keepAlive"></router-view>
			</div>
		</transition>

		<el-dialog title="Unread Messages" :class="newsDialogCss" :visible.sync="NewsVisible" v-model="NewsVisible"
			:close-on-click-modal="false">
			<div>
				<el-tag v-for="(tag, index) in tagNews" :key="index" closable class="tag-new" :type="tag.type">
					{{ tag.name }}
				</el-tag>
			</div>
		</el-dialog>

		<div class="v-modal" @click="closeZModalShadow" v-show="NewsVisible" tabindex="0" style="z-index: 2917"></div>

		<div class="v-modal" @click="collapse" v-show="SidebarVisible" tabindex="0" style="z-index: 2917"></div>
		<el-dialog :visible.sync="dialogVisible" width="380px">
			<div style="
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;">
				<div>
					<span style="font-size:13px;font-weight: bold;">关注公众号,自动开启微信实时通知服务</span>
				</div>
				<img style="width: 300px; height:300px;" :src="QrCodeUrl" alt="">
				<div style="font-size:13px;font-weight: bold;">
					<div style="display: flex;width: 250px;justify-content: space-around;">
						<p>通知内容</p>
						<div style="display: flex;justify-content: center;align-items: center;">
							<img style="width: 20px;height: 20px;" src="./assets/Notify_success.jpg" alt="">
							<span>发货通知</span>
						</div>
						<div style="display: flex;justify-content: center;align-items: center;">
							<img style="width: 20px;height: 20px;" src="./assets/Notify_success.jpg" alt="">
							<span>开票通知</span>
						</div>
					</div>

				</div>
			</div>

			<span slot="footer" class="dialog-footer">
			</span>
		</el-dialog>
		<el-drawer :visible.sync="isShowUpdata" direction="rtl" size="50%" title="下载中心" :before-close="handleCloseUpdata">
			<div class="drawer_wrap">
				<el-table :data="systemExpList" default-expand-all border style="width: 100%">
					<el-table-column type="expand">
						<template slot-scope="props">
							<el-form label-position="left" :inline="true" class="demo-table-expand"
								v-for="(item, index) in props.row.downloadUrlList" :key="index">
								<el-form-item style="margin-bottom: 0" label="导出表格：">
									<span style="color: #409eff; cursor: pointer" @click="uploadForm(item.url)"><i
											class="el-icon-paperclip"></i> {{ item.fileName }}</span>
								</el-form-item>
							</el-form>
						</template>
					</el-table-column>
					<el-table-column label="任务名称" prop="taskName"> </el-table-column>
					<el-table-column label="任务时间" prop="createTime">
					</el-table-column>
					<el-table-column label="任务状态" prop="taskStatus">
					</el-table-column>
				</el-table>
				<el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
					:total="systemTotal" @current-change="handleCurrentChange" style="float: right"></el-pagination>
			</div>
		</el-drawer>
		<!--      <el-dialog-->
		<!--          title="售后待处理"-->
		<!--          :visible.sync="notifyDialogVisible"-->
		<!--          width="380px">-->
		<!--        <div style="-->
		<!--    width: 100%;-->
		<!--    height: 100%;-->
		<!--    display: flex;-->
		<!--    flex-direction: column;-->
		<!--    justify-content: center;-->
		<!--    align-items: center;">-->
		<!--        </div>-->
		<!--        <span slot="footer" class="dialog-footer">-->
		<!--    <el-button type="primary" @click="notifyDialogVisible = false">前往处理</el-button>-->
		<!--  </span>-->
		<!--      </el-dialog>-->
		<!-- 格式化工具 -->
		<el-dialog title="格式化工具" :visible.sync="formatDialog" :close-on-click-modal="false">
			<div style="display: flex;align-items: center;">
				<el-input type="textarea" rows="12" style="flex: 1" placeholder="输入想要转换的数据" v-model.trim="initValue"></el-input>
				<div>
					<el-input type="text" placeholder="符号" v-model="symbol"
						style="width:90px;margin:0px 15px 10px;display:block"></el-input>
					<el-button type="primary" style="margin:0 15px;" plain @click="handleFormat">转换 =></el-button>
				</div>
				<el-input type="textarea" rows="12" style="flex: 1" placeholder="转换的结果数据" v-model.trim="resValue"></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" v-preventClick v-clipboard:copy="resValue" v-clipboard:success="onCopy"
					v-clipboard:error="onError">复制</el-button>
				<el-button type="primary" v-preventClick plain @click="formatClear">清空</el-button>
			</span>
		</el-dialog>
		<!-- 弹窗提示订单操作 -->
		<el-dialog title="" :visible.sync="showOrderPop" :close-on-click-modal="false" width="40%">
			<div style="text-align: center;padding:20px 40px;">
				<p style="margin-bottom: 40px;"><i class="el-icon-warning" style="font-size:60px;color:orange"></i></p>
				<div style="margin:15px 0 30px;font-size: 16px;">
					<!-- 超72小时未反馈物流 -->
					<div class="flex flex-sb flex-center mgb15" v-if="$store.state.over72Hours.num > 0">
						<p>您有{{ $store.state.over72Hours.num }}笔订单<span style="color:orange">超72小时未反馈物流</span>，请及时处理！</p>
						<el-button type="primary"
							@click="$router.push('/OrderManagement/SubOrder?orderContractStatus=3'); showOrderPop = false">立即处理</el-button>
					</div>
					<!-- 售后订单 -->
					<div class="flex flex-sb flex-center mgb15" v-if="$store.state.aftersales.num > 0">
						<p>您有{{ $store.state.aftersales.num }}笔<span style="color:orange">售后订单</span>需要审核，请及时处理！</p>
						<el-button type="primary"
							@click="$router.push('/AfterSalesService/AfterSaleList/Index1'); showOrderPop = false">立即处理</el-button>
					</div>
					<!-- 确认货源 -->
					<div class="flex flex-sb flex-center mgb15" v-if="$store.state.toConfirmGoodSource.num">
						<p>您有{{ $store.state.toConfirmGoodSource.num }}笔订单需要<span style="color:orange">确认货源</span>请及时处理！</p>
						<el-button type="primary"
							@click="$router.push('/OrderManagement/SubOrder?orderContractStatus=1'); showOrderPop = false">立即处理</el-button>
					</div>
					<!-- 超时确认货源 -->
					<div class="flex flex-sb flex-center mgb15" v-if="$store.state.overConfirmGoodSource.num > 0">
						<p>您有{{ $store.state.overConfirmGoodSource.num
						}}笔订单已<span style="color:orange">超时确认货源</span>请及时处理！</p>
						<el-button type="primary"
							@click="$router.push('/OrderManagement/SubOrder?orderContractStatus=2'); showOrderPop = false">立即处理</el-button>
					</div>
					<!-- 报装订单 -->
					<div class="flex flex-sb flex-center" v-if="$store.state.repairOrder.num > 0">
						<p>您有{{ $store.state.repairOrder.num
						}}笔报装订单，请及时处理！</p>
						<el-button type="primary"
							@click="$router.push('/OrderManagement/RepairInstallOrder'); showOrderPop = false">立即处理</el-button>
					</div>
				</div>
				<!-- <el-button type="primary" @click="jump">前往处理</el-button> -->
			</div>
		</el-dialog>
    <!-- 入驻协议 -->
    <residential-agreement account="" ref="residentialAgreement" :showBtn="false"/>
	</div>
</template>
<script>
import { getButtonList } from './promissionRouter'
import Sidebar from "./components/Sidebar";
import ScrollPane from "./components/ScrollPane";
import {
	getUserByToken, WeChatGetQrCodeUrl,
	KSAXApiRequest,
	GetAllReseller
} from "./api/api";
import applicationUserManager from "./Auth/applicationusermanager";
import userAuth from "./Auth/UserAuth";
import ResidentialAgreement from "@/components/residentialAgreement.vue";

export default {
	components: { Sidebar, ScrollPane, ResidentialAgreement },
	mixins: [userAuth],
	data() {
		return {
			QrCodeUrl: '',
			dialogVisible: false,
			notifyDialogVisible: true,
			sysName: this.$store.state.tenancyName || "欢迎来到ERP系统",
			sysNameShort: "ERP",
			NewsVisible: false,
			SidebarVisible: false,
			collapsed: false,
			zModalShadow: false,
			collapsedClass: "menu-expanded",
			ispc: false,
			sysUserName: "",
			newsDialogCss: "news-dialog",
			sysUserAvatar: "",
			isCollapse: false,
			tagsList: [],

			routes: [],
			tagNews: [
				{ name: "前后端分离", type: "" },
				{ name: "vue.js", type: "" },
				{ name: "DDD领域驱动设计", type: "success" },
				{ name: "标签三", type: "info" },
				{ name: "欠费警告！", type: "warning" },
				{ name: "异常报告！", type: "danger" },
			],
			isShowUpdata: false,
			systemTotal: 0,
			systemExpList: [],
			systemPageIndex: 1,
			systemPageSize: 10,

			formatDialog: false,
			initValue: null,
			resValue: null,
			symbol: ',',
			subForm: {
				BrandId: null,
				TypeId: null,
				SearchType: 1,
				SupId: null,
				SearchKey: null,
				ProductName: null,
				ReceiverName: null,
				ReceiverPhone: null,
				UserParentName: null,
				ProductSupplier: null,
				OrderStatus: 0,
				PayType: -1,
				SpuId: null,
				OrderTimeStart: (() => {
					let date = new Date()
					if (this.$route.query.LCCWRecordId) {
						return ''
					} else {
						return this.$utils.filterDate(
							new Date(date.getTime() - 3600 * 1000 * 24 * 30)
						)
					}
				})(),
				OrderTimeEnd: (() => {
					let date = new Date()
					if (this.$route.query.LCCWRecordId) {
						return ''
					} else {
						return this.$utils.filterDate(new Date(date.getTime() + 3600 * 1000 * 24))
					}
				})(),
				CompleteTimeStart: null,
				CompleteTimeEnd: null,
				PayTimeStart: null,
				PayTimeEnd: null,
				ShipTimeStart: null,
				ShipTimeEnd: null,
				IsExceptional: -1,
				IsHasBuy: -1,
				IsHasLogistics: -1,
				BuySupplier: null,
				Plate: -1,
				RewardType: null,
				IsSeparate: null,
				IsFirstOrder: null,
				UserType: null,
				IsDFSOrder: null,
				LogisticsNo: null,
				PageIndex: 1,
				PageSize: 10,
				UnShipType: null,
				OrderContractStatus: null
			},
			showOrderPop: false,
			ruleContentHeight: 0
		};
	},
	methods: {
    agree() {
      this.$refs.residentialAgreement.show()
    },
		// jump() {
		// 	let num1 = this.$store.state.aftersales.num
		// 	let num2 = this.$store.state.overConfirmGoodSource.num
		// 	let num3 = this.$store.state.over72Hours.num
		// 	let num4 = this.$store.state.toConfirmGoodSource.num
		// 	this.showOrderPop = false
		// 	if (num1 > 0) {
		// 		this.$router.push('/AfterSalesService/AfterSaleList/Index1')
		// 	} else if (num2 > 0) {
		// 		this.$router.push('/OrderManagement/SubOrder?orderContractStatus=2')
		// 	} else if (num3 > 0) {
		// 		this.$router.push('/OrderManagement/SubOrder?orderContractStatus=3')
		// 	} else if (num4 > 0) {
		// 		this.$router.push('/OrderManagement/SubOrder?orderContractStatus=1')
		// 	}
		// },
		getFiveColumsData() {
			GetAllReseller({ SkipCount: 0, MaxResultCount: 10 }).then(res => {
				if (res.data.success) {
					this.subForm.SupId = res.data.result.items[0].remoteKey
					// 查询待确认货源数量
					KSAXApiRequest({
						"path": "ChildOrder/List",
						"parms": "",
						"parmsJson": { ...this.subForm, OrderContractStatus: 1, isGetNumber: true }
					}).then((res) => {
						if (res.data.success) {
							this.$store.commit("setToConfirmGoodSource", res.data.response.dataCount);
						} else {
							this.$store.commit("setToConfirmGoodSource", 0);
						}
					});
					// 查询超时确认货源数量
					KSAXApiRequest({
						"path": "ChildOrder/List",
						"parms": "",
						"parmsJson": { ...this.subForm, OrderContractStatus: 2, isGetNumber: true }
					}).then((res) => {
						if (res.data.success) {
							this.$store.commit("setOverConfirmGoodSource", res.data.response.dataCount);
						} else {
							this.$store.commit("setOverConfirmGoodSource", 0);
						}
					});
					// 查询超72小时未反馈物流
					KSAXApiRequest({
						"path": "ChildOrder/List",
						"parms": "",
						"parmsJson": { ...this.subForm, OrderContractStatus: 3, isGetNumber: true }
					}).then((res) => {
						if (res.data.success) {
							this.$store.commit("setOver72Hours", res.data.response.dataCount);
						} else {
							this.$store.commit("setOver72Hours", 0);
						}
					});
					// 查询待发货
					KSAXApiRequest({
						"path": "ChildOrder/List",
						"parms": "",
						"parmsJson": { ...this.subForm, OrderStatus: 20, isGetNumber: true }
					}).then((res) => {
						if (res.data.success) {
							this.$store.commit("setToDelivery", res.data.response.dataCount);
						} else {
							this.$store.commit("setToDelivery", 0);
						}
					});
					// 查询售后订单
					KSAXApiRequest({
						path: 'AfterSaleOrder/AfterSaleListForERPPost',
						parmsJson: {
							pageIndex: 1,
							pageSize: 10,
							HandleStatus: 0,
							SupplierIds: this.subForm.SupId,
							OrderNo: '',
							isGetNumber: true
						}
					}).then(res => {
						if (res.data.success) {
							this.$store.commit("setAftersales", res.data.response.dataCount);
						} else {
							this.$store.commit("setAftersales", 0);
						}
					})
					// 查询报装订单
					KSAXApiRequest({
						"path": "Order_ApplyInstall/ApplyInstallDataList",
						"parms": "",
						"parmsJson": {
							AccountId: 0,
							SearchKeyType: 1,
							SearchKey: null,
							ModelCode: null,
							AccountType: null,
							ApplyInstallStatus: 1,
							ContactPhone: null,
							ContactName: null,
							StartTime: null,
							EndTime: null,
							PageIndex: 1,
							PageSize: 10,
							SupIds: [this.subForm.SupId],
							SupName: '',
							IsRobot: null,
							SelectNumber: -1,
							RemainNumber: 3
						}
					}).then((res) => {
						if (res.data.success) {
							this.$store.commit("setRepairOrder", res.data.response.dataCount);
						} else {
							this.$store.commit("setRepairOrder", 0);
						}
					});
				}
			})
		},
		onFormat() {
			this.initValue = null
			this.resValue = null
			this.formatDialog = true
		},
		handleFormat() {
			if (!this.initValue) retrun
			this.resValue = this.initValue.replace(/\r|\n|↵/g, this.symbol || ' ')
		},
		onCopy(e) {
			this.$message.success("内容已复制到剪切板！");
		},
		onError(e) {
			this.$message.error("抱歉，复制失败！");
		},
		formatClear() {
			this.initValue = null
			this.resValue = null
		},
		handleOpenUpdata() {
			this.isShowUpdata = true;
			this.getResellerId();
		},
		handleCloseUpdata() {
			this.isShowUpdata = false;
		},
		getResellerId() {
			GetAllReseller({ SkipCount: 0, MaxResultCount: 10 }).then(res => {
				if (res.data.success) {
					this.resellerId = res.data.result.items[0].remoteKey
					this.getSystemExportTaskList();
				}
			})
		},
		getSystemExportTaskList() {
			let that = this;
			let params = {
				path: 'ChildOrder/DownLoadList',
				parmsJson: {
					supId: this.resellerId,
					pageIndex: that.systemPageIndex,
					pageSize: that.systemPageSize,
				}
			};
			KSAXApiRequest(params).then((res) => {
				if (res.data.success) {
					that.systemTotal = res.data.response.dataCount;
					that.systemExpList = res.data.response.data;
				} else {
					that.$message.error(res.data.msg);
				}
			});
		},
		handleCurrentChange(val) {
			this.systemPageIndex = val;
			this.getSystemExportTaskList();
		},
		handleSizeChange(e) {
			this.systemPageSize = e;
			this.getSystemExportTaskList();
		},
		uploadForm(url) {
			// debugger
			window.open(url);
		},
		// getQrCode
		async getQrCode() {
			let res = await WeChatGetQrCodeUrl();
			if (res.data.success) {
				this.QrCodeUrl = res.data.result;
				this.dialogVisible = true;
			} else {
				this.$message.error(res.data.error.message)
			}
			// console.log('res', res);
		},
		gotappath(Path) {
			// console.log(Path);
			this.$router.replace({
				path: Path,
			});
		},
		handleOpen(key, keyPath) {
			// console.log(key, keyPath);
		},
		closeZModalShadow() {
			this.NewsVisible = false;
		},
		toindex() {
			this.$router.replace({
				path: "/",
			});
		},
		handleClose(key, keyPath) {
			// console.log(key, keyPath);
		},
		onSubmit() {
			// console.log("submit!");
		},
		myNews() {
			this.newsDialogCss += " show ";
			this.NewsVisible = true;
		},
		handleopen() {
			//console.log('handleopen');
		},
		handleclose() {
			//console.log('handleclose');
		},
		handleselect: function (a, b) {
		},
		//退出登录
		logout: function () {
			var _this = this;
			this.$confirm("确认退出吗?", "提示", {
				closeOnClickModal: false,
				//type: 'warning'
			})
				.then(() => {
					// sessionStorage.removeItem("isSignIn");
					window.localStorage.removeItem("user");
					window.localStorage.removeItem("Token");
					window.localStorage.removeItem("TokenExpire");
					window.localStorage.removeItem("NavigationBar");
					window.localStorage.removeItem("refreshtime");
					window.localStorage.removeItem("router");
					sessionStorage.removeItem("Tags");
					// 清空租户信息  左上角展示
					sessionStorage.removeItem("Abp.TenantId")
					// sessionStorage.removeItem("tenancyName")
					this.$store.state.tenantId = null
					this.$store.state.tenancyName = ''
					global.antRouter = [];

					this.tagsList = [];
					this.routes = [];
					this.$store.commit("saveTagsData", "");

					if (global.IS_IDS4) {
						applicationUserManager.logout();
					} else {
						_this.$router.push("/login");
						window.location.reload();
					}
				})
				.catch(() => {
				});
		},
		//设置
		Setting: function () {
			var _this = this;
			_this.$router.push("/Permission/Sys/ChangePassword");
		},
		//折叠导航栏
		collapse: function () {
			this.collapsed = !this.collapsed;

			if (this.ispc) {
				if (this.collapsed) {
					this.collapsedClass = "menu-collapsed";
				} else {
					this.collapsedClass = "menu-expanded";
				}
			} else {
				// mobile
				if (this.collapsed) {
					this.SidebarVisible = true;
					this.collapsedClass = "menu-collapsed-mobile";
				} else {
					this.SidebarVisible = false;
					this.collapsedClass = "menu-expanded-mobile";
				}

				this.collapsedClass += " mobile-ex ";
			}
			this.isCollapse = !this.isCollapse;
		},
		collapseFa: function () {
			if (!this.ispc) {
				this.collapse();
			}
		},
		showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName(
				"submenu-hook-" + i
			)[0].style.display = status ? "block" : "none";
		},
		isActive(path) {
			return path === this.$route.fullPath;
		},
		// 关闭单个标签
		closeTags(index) {
			const delItem = this.tagsList.splice(index, 1)[0];
			const item = this.tagsList[index]
				? this.tagsList[index]
				: this.tagsList[index - 1];
			if (item) {
				delItem.path === this.$route.fullPath && this.$router.push(item.path);

				this.$store.commit("saveTagsData", JSON.stringify(this.tagsList));
			} else {
				this.$router.push("/");
			}
		},
		// 关闭全部标签
		closeAll() {
			this.tagsList = [];
			this.$router.push("/");
			sessionStorage.removeItem("Tags");
		},
		// 关闭其他标签
		closeOther() {
			const curItem = this.tagsList.filter((item) => {
				return item.path === this.$route.fullPath;
			});
			this.tagsList = curItem;

			sessionStorage.setItem("Tags", JSON.stringify(this.tagsList));
		},
		// 设置标签
		setTags(route) {
			// 旧代码
			// if (!route.meta.NoTabPage) {
			//   const isExist = this.tagsList.some((item) => {
			//     return item.path === route.fullPath;
			//   });
			//   !isExist &&
			//     this.tagsList.push({
			//       title: route.meta.title,
			//       path: route.fullPath,
			//       // name: route.matched[1].components.default.name
			//     });
			// }

			// 新代码
			if (!route.meta.NoTabPage) {
				const idx = this.tagsList.findIndex((item) => {
					return item.path.indexOf(route.path) > -1
				});
				if (idx > -1) {
					if (this.tagsList[idx].path !== route.fullPath) {
						this.tagsList.splice(idx, 1)
						this.tagsList.push({
							title: route.meta.title,
							path: route.fullPath
						})
					}
				} else {
					this.tagsList.push({
						title: route.meta.title,
						path: route.fullPath
					})
				}
			}
		},
		// 当关闭所有页面时隐藏
		handleTags(command) {
			command === "other" ? this.closeOther() : this.closeAll();
		},
		getUserInfoByToken(token) {
			var _this = this;
			var loginParams = { token: token };
			getUserByToken(loginParams).then((data) => {
				this.logining = false;
				if (!data.success) {
					_this.$message({
						message: data.message,
						type: "error",
					});
				} else {
					_this.$notify({
						type: "success",
						message: `欢迎管理员：${data.response.uRealName} ！`,
						duration: 3000,
					});

					_this.sysUserName = data.response.uRealName;
					window.localStorage.user = JSON.stringify(data.response);
				}
			});
		},
		operationManual() {
			let { href } = this.$router.resolve({ path: `/OperationBook`, });
			window.open(href, "_blank");
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (this.$refs.ruleContent.offsetHeight) {
				this.ruleContentHeight = this.$refs.ruleContent.offsetHeight
			}
		})
		// let dev = process.env.NODE_ENV.toLowerCase().indexOf("dev") != -1;
		// if (!dev) {
		//   this.getConfigJson();
		// }
		let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
		var buttonList = getButtonList('/PublicPermissionConfig', routers);
		buttonList.forEach(item => {
			if (item.Func === "showOA") {
				this.$store.commit("setIsShowOA", true);
			}
			if (item.Func === "showFaceVersion") {
				this.$store.commit("setIsShowFaceVersion", true);
			}
			if (item.Func === "showAfterSales") {
				this.$store.commit("setIsShowAfterSales", true);
			}
		})
		var tags = sessionStorage.getItem("Tags")
			? JSON.parse(sessionStorage.getItem("Tags"))
			: [];

		if (tags && tags.length > 0) {
			this.tagsList = tags;
		}

		var NavigationBar = JSON.parse(
			window.localStorage.router ? window.localStorage.router : null
		);
		// var NavigationBar = global.antRouter;

		if (this.routes.length <= 0 && NavigationBar && NavigationBar.length >= 0) {
			this.routes = NavigationBar;
		}
	},
	updated() {
		var user = JSON.parse(
			window.localStorage.user ? window.localStorage.user : null
		);
		if (user) {

			this.sysUserName = user.name || "老张的哲学";

			//this.sysUserName = user.uRealName || "老张的哲学";
			this.sysUserAvatar = user.avatar || "../assets/user.png";
		}

		var NavigationBar = JSON.parse(
			window.localStorage.router ? window.localStorage.router : null
		);
		if (NavigationBar && NavigationBar.length >= 0) {
			if (
				this.routes.length <= 0 ||
				JSON.stringify(this.routes) != JSON.stringify(NavigationBar)
			) {
				this.routes = NavigationBar;
			}
		}
	},
	computed: {
		showTags() {
			if (this.tagsList.length > 1) {
				this.$store.commit("saveTagsData", JSON.stringify(this.tagsList));
			}
			return this.tagsList.length > 0;
		},
		toConfirmGoodSource() {
			return this.$store.state.toConfirmGoodSource.result
		},
		over72Hours() {
			return this.$store.state.over72Hours.result
		},
		overConfirmGoodSource() {
			return this.$store.state.overConfirmGoodSource.result
		},
		aftersales() {
			return this.$store.state.aftersales.result
		},
		repairOrder() {
			return this.$store.state.repairOrder.result
		},
		getAllDataFlag() {
			return this.toConfirmGoodSource && this.over72Hours && this.overConfirmGoodSource && this.aftersales && this.repairOrder
		}
	},
	watch: {
		// 对router进行监听，每当访问router时，对tags的进行修改
		$route: async function (newValue, from) {
			if (global.IS_IDS4) {
				await this.refreshUserInfo();
			}
			this.setTags(newValue);

			const tags = this.$refs.tag;
			this.$nextTick(() => {
				if (tags) {
					for (const tag of tags) {
						if (tag.to.path === this.$route.path) {
							this.$refs.scrollPane.moveToTarget(tag, tags);
							// when query is different then update
							// if (tag.to.fullPath !== this.$route.fullPath) {
							//     this.$store.dispatch('tagsView/updateVisitedView', this.$route)
							// }
							break;
						}
					}
				}
			});
			if (newValue != from && from.name == 'login' && !['register', 'login'].includes(newValue.name) && newValue.path.indexOf('SupEnter') == -1 && localStorage.getItem('Token') && localStorage.getItem('Token') != 'undefined') {
				this.getFiveColumsData()
			}
		},
		getAllDataFlag: {
			handler(n, o) {
				if (n) {
					// 开始弹窗提示
					if (this.$store.state.toConfirmGoodSource.num || this.$store.state.over72Hours.num || this.$store.state.overConfirmGoodSource.num || this.$store.state.aftersales.num || this.$store.state.repairOrder.num) {
						this.showOrderPop = true
					}
				}
			},
			immediate: true,
			deep: true
		}
	},
	created() {
		// 第一次进入页面时，修改tag的值
		this.setTags(this.$route);
		this.ispc = window.screen.width > 680;

		if (this.ispc) {
			this.collapsedClass = "menu-expanded";
		} else {
			this.collapsedClass = "menu-expanded-mobile mobile-ex";
			this.collapsed = true;
			this.collapse();
		}
		// console.log(this.$route.name)
		if (this.$route.name != 'login' && this.$route.name != 'register' && localStorage.getItem('Token') && localStorage.getItem('Token') != 'undefined') {
			this.getFiveColumsData()
		}
	},
};
</script>

<style lang="css">
@import "./style/home.css";

.shop_title {
	font-size: 20px;
	font-weight: 700;
}

.el-breadcrumb {
	line-height: 60px !important;
}

.drawer_wrap {
	padding: 20px;
	height: 90vh;
	width: 100%;
	overflow-y: auto;
}

.download_box {
	position: fixed;
	bottom: 40px;
	right: 10px;
	z-index: 999;
	min-width: 150px;
	min-height: 150px;
	background: rgba(0, 0, 0, .8);
	box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	border-radius: 10px;
	overflow: hidden;
	padding: 5px;
}

.download_box>i {
	position: absolute;
	top: 5px;
	right: 5px;
	cursor: pointer;
	display: inline-block;
	color: #fff;
}

.notice-box {
	text-align: center;
}

.notice-box ul li {
	margin-bottom: 10px;
}

.float-left {
	position: fixed;
	bottom: 40px;
	right: 0;
	z-index: 999;
	font-size: 30px;
	font-weight: 700;
}
</style>

<style>
.flex {
	display: flex;
}

.flex-sb {
	justify-content: space-between;
}

.mgb15 {
	margin-bottom: 15px;
}

.menu-collapsed .el-icon-arrow-right:before {
	display: none;
}

.tags {
	position: relative;
	overflow: hidden;
	border: 1px solid #f0f0f0;
	margin-bottom: 20px;
	background: #f0f0f0;
}

.userinfo {
	flex: 1;
	display: flex;
	justify-content: flex-start;
	align-items: center;
}

.up_data_icon {
	margin-right: 20px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	cursor: pointer;
	line-height: 30px;
	font-size: 14px;
}

.up_data_icon i {
	font-size: 20px;
	margin-right: 5px;
}

.up_data_icon span {
	font-size: 14px;
	line-height: 30px;
}

.badge {
	background-color: #f56c6c;
	border-radius: 10px;
	color: #fff;
	display: inline-block;
	font-size: 12px !important;
	height: 18px;
	line-height: 18px;
	padding: 0 6px;
	text-align: center;
	white-space: nowrap;
	margin-left: 5px;
}

.tags ul {
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	padding: 0;
	margin: 0;
	display: none;
}

.tags-li {
	float: left;
	margin: 3px 5px 2px 3px;
	border-radius: 3px;
	font-size: 13px;
	overflow: hidden;
	height: 23px;
	line-height: 23px;
	border: 1px solid #e9eaec;
	background: #fff;
	padding: 3px 5px 4px 12px;
	vertical-align: middle;
	color: #666;
	-webkit-transition: all 0.3s ease-in;
	transition: all 0.3s ease-in;
}

.tags-li-icon {
	cursor: pointer;
}

.tags-li:not(.active):hover {
	background: #f8f8f8;
}

.tags-li-title {
	float: left;
	max-width: 80px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	margin-right: 5px;
	color: #666;
	text-decoration: none;
}

.tags-close-box {
	box-sizing: border-box;
	text-align: center;
	z-index: 10;
	float: right;
	margin-right: 1px;
	line-height: 2;
}
</style>
<style>
.news-dialog {
	background: #fff;
	z-index: 3000 !important;
	position: fixed;
	height: 100vh;
	width: 100%;
	max-width: 260px;
	top: 60px !important;
	left: 0 !important;
	-webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
	box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
	-webkit-transition: all 0.25s cubic-bezier(0.7, 0.3, 0.1, 1);
	transition: all 0.25s cubic-bezier(0.7, 0.3, 0.1, 1);
	-webkit-transform: translate(100%);
	z-index: 40000;
	left: auto !important;
	right: 0 !important;
	transform: translate(0);
}

.news-dialog .el-dialog {
	margin: auto !important;
	-webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
	box-shadow: none;
	width: 100%;
}

.news-dialog.show {
	transform: translate(0);
}

.tag-new {
	width: 100%;
	margin: 10px 0;
}

@media screen and (max-width: 680px) {
	.collapsedLogo {
		display: none;
	}

	.el-dialog {
		width: 90% !important;
	}

	.content-expanded {
		max-width: 100% !important;
		/* max-height: calc(100% - 60px); */
	}

	.mobile-ex {
		background: #fff;
		z-index: 3000;
		position: fixed;
		height: 100vh;
		width: 100%;
		max-width: 260px;
		top: 0;
		left: 0;
		-webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
		box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
		-webkit-transition: all 0.25s cubic-bezier(0.7, 0.3, 0.1, 1);
		transition: all 0.25s cubic-bezier(0.7, 0.3, 0.1, 1);
		-webkit-transform: translate(100%);
		z-index: 40000;
		left: auto;
		right: 0;
		transform: translate(100%);
	}

	.mobile-ex.menu-collapsed-mobile {
		transform: translate(0);
	}

	.el-menu--collapse {
		width: 100% !important;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner,
	.el-cascader.el-cascader--medium {
		width: 100% !important;
	}

	.toolbar.roles {
		width: 100% !important;
	}

	.toolbar.perms {
		width: 800px !important;
	}

	.toolbar.perms .box-card {
		width: 100% !important;
	}

	.login-container {
		width: 300px !important;
	}

	/* .count-test label {

          } */
	.content-wrapper .tags {
		margin: 0px;
		padding: 0px;
	}
}

.header_tab_view {
	display: flex;
	justify-content: flex-start;
	align-items: center;
}

.tab_box1 {
	width: 40%;
}

.tab_input {
	flex: 1;
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.notice1 {
	background: #ebeef5;
}

.notice2 {
	background: #e4e7ed;
}

.notice3 {
	background: #ebeef5;
}

.notice4 {
	background: #e4e7ed;
}

.notice_item {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	border-bottom: 1px solid #dddddd;
	padding: 20px 10px;
	margin-bottom: 10px;
}

.notice_item_content {
	font-size: 12px;
	color: #999999;
	flex: 1;
	padding: 0 20px;
}

.notice_title {
	color: #333333;
	font-weight: bold;
	margin-bottom: 10px;
}

.notice_info {
	margin-bottom: 10px;
}

.notice_info>span {
	margin-right: 20px;
}

.notice_info_chat {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.notice_info_chat>span {
	color: #333333;
}
</style>

<style>
.tags-view-container {
	height: 34px;
	width: calc(100% - 60px);
	float: left;
}

.tags-view-container .tags-view-wrapper .tags-view-item {
	display: inline-block;
	position: relative;
	cursor: pointer;
	height: 26px;
	line-height: 26px;
	border: 1px solid #d8dce5;
	color: #495060;
	background: #fff;
	padding: 0 8px;
	font-size: 12px;
	margin-left: 5px;
	margin-top: 4px;
}

.tags-view-container .tags-view-wrapper .tags-view-item:first-of-type {
	margin-left: 15px;
}

.tags-view-container .tags-view-wrapper .tags-view-item:last-of-type {
	margin-right: 15px;
}

.tags-view-container .tags-view-wrapper .tags-view-item.active::before {
	content: "";
	background: #2d8cf0;
	display: inline-block;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	position: relative;
	margin-right: 2px;
}

.tags-view-container .contextmenu {
	margin: 0;
	background: #fff;
	z-index: 3000;
	position: absolute;
	list-style-type: none;
	padding: 5px 0;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 400;
	color: #333;
	box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.tags-view-container .contextmenu li {
	margin: 0;
	padding: 7px 16px;
	cursor: pointer;
}

.tags-view-container .contextmenu li:hover {
	background: #eee;
}
</style>

<style>
.tags-view-wrapper .tags-view-item .el-icon-close {
	width: 16px;
	height: 16px;
	vertical-align: 2px;
	border-radius: 50%;
	text-align: center;
	transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	transform-origin: 100% 50%;
}

.tags-view-wrapper .tags-view-item .el-icon-close:before {
	transform: scale(0.6);
	display: inline-block;
	vertical-align: -3px;
}

.tags-view-wrapper .tags-view-item .el-icon-close:hover {
	background-color: #ef2b74;
	color: #fff;
}

.content-az,
.el-scrollbar__view {
	height: 100%;
}

.customDialogCss {
	/*width:30px;*/
	/*height:430px;*/
}
</style>
